import React, {memo, useMemo} from "react";
import styles from "./styles.module.scss";
import {MessageModel} from "@/app/api/messages";
import {TextBold16, TextMedium12, TextMedium16} from "@/app/components/texts";
import LazyAssets from "@/app/utils/assets_widget";
import {useMessageTime} from "@/app/utils/custom_function";
import classNames from "classnames";

interface Props {
  message: MessageModel | undefined;
  currentUserId: number | undefined;
}

const MessageWidget: React.FC<Props> = ({message, currentUserId}) => {
  const isMyMessage = useMemo(() => message?.authorId === currentUserId, [currentUserId, message?.authorId]);
  return (<div className={classNames(styles.message, {[styles.my]: isMyMessage})}>
    <TextBold16 text={message?.authorUsername}/>
    <TextMedium16 text={message?.content} className={styles.content}/>
    <div className={styles.footer}>
      <TextMedium12 text={useMessageTime(message?.sentAt)} className={styles.time}/>
      {/*<LazyAssets.Sent/>*/}
    </div>
  </div>);
};

export default memo(MessageWidget);